























































import TheTemplateJ from "@/general/components/templates/TheTemplateJ.vue";
import JMessageArticleList from "@/general/components/pages/parts/ThanksPointList/JMessageArticleList.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import { getPointHistoryList } from "@/general/store/api";
import IconNoSearchResult from "@/common/components/icons/IconNoSearchResult.vue";
import globals from "@/general/store/modules/globals";
import store from "@/general/store";
import ThanksPointApi from "@/general/api/thanksPointApi";
import {
  ListResponse,
  Transaction,
  ThanksPoint,
  ThankPointSearchByUser
} from "@/general/store/models";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import CONST_DATA from "@/general/mixins/const/constData";
import ThanksPointSearch from "@/general/components/pages/parts/ThanksPointSearch/index.vue";
import ThanksPointSearchNotFound from "@/general/components/pages/parts/ThanksPointSearch/not-found.vue";
import { checkLengthInput, checkNullInput } from "@/general/utils/helper";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheTemplateJ,
    JMessageArticleList,
    IconNoSearchResult,
    ThanksPointSearch,
    ThanksPointSearchNotFound
  },
  store: store
})
export default class ThanksPointList extends Vue {
  @Prop({ type: String, default: "" }) searchKeyword!: string;
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;
  thanksPointList: any = [];
  userSearchList: any = [];
  currentPage!: number;
  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: `${CONST_DATA.SITE_MAP.THANKS_POINT}?`
  };
  isPagination: boolean;
  keyword = "";
  isSearch = false;
  hasSearchResult = false;
  isLoading = true;
  error = "";

  breadcrumb: any = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "サンクスメッセージ",
      url: "",
      pageType: "lower"
    }
  ];

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  get messageArticleList() {
    return this.thanksPointList;
  }

  get messageArticleListLength() {
    return this.messageArticleList.length;
  }

  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get messsageThreadEnabled() {
    return auth.user?.thread_enabled;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.breadcrumb[1].text = this.thanksPointName + "メッセージ";
    commons.setbreadcrumb(this.breadcrumb);
    this.isPagination = false;
    await this.initThanksPointList();
    setTimeout(() => {
      this.isLoading = false;
      // サンクス機能が有効化されていない場合、エラーページに飛ばす。
      // 少し待たないとデータ取得に間に合わず、常に/system-error/ページに飛ばされてしまうため、setTimeoutの中に記述している
      if (this.thanksFunctionEnabled === false) {
        if (this.ssoFlg) {
          // SSOログイン時は行き止まりエラー画面へ
          window.location.href = "/session-time-out/";
        } else {
          LocalStorage.removeAll();
          AuthApi.getLogout();
          auth.remove();
          window.location.href = "/system-error/";
        }
        return;
      }
    }, 1000);
  }

  async initThanksPointList() {
    this.isLoading = true;
    this.hasSearchResult = false;
    this.thanksPointList = [];
    this.userSearchList = [];
    this.error = "";
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const searchParam = urlParams.get("search") as string;
    this.handleParam(searchParam);
    this.isSearch = urlParams.has("search");

    const checkValidLength = checkLengthInput(this.keyword, 50);
    if (!checkValidLength?.isValid) {
      this.isLoading = false;
      this.error = checkValidLength?.error;
      this.isPagination = false;
      return false;
    }

    const thanksPointList: ListResponse<ThanksPoint> = await ThanksPointApi.getThankPointList(
      this.currentPage,
      this.pageSize,
      this.keyword
    );

    const message_type = "sent";
    // スレッド機能利用要否 利用するで、一覧から選択したはサンクスメッセージの詳細へ遷移
    // DX_IC-942
    if (!this.isSearch) {
      if (this.messsageThreadEnabled === true) {
        thanksPointList.results?.forEach((resObj: ThanksPoint) => {
          this.thanksPointList.push({
            id:
              resObj?.message_type == message_type
                ? resObj?.to_user?.using_employee_id
                : resObj?.from_user?.using_employee_id == 0
                ? ""
                : resObj?.from_user?.using_employee_id,
            user_id:
              resObj?.message_type == message_type
                ? resObj?.to_user?.using_employee_id
                : resObj?.from_user?.using_employee_id == 0
                ? ""
                : resObj?.from_user?.using_employee_id,
            name:
              resObj?.message_type == message_type
                ? resObj?.to_user?.user_name
                : resObj?.from_user?.user_id == 0
                ? "－"
                : resObj?.from_user?.user_name,
            date: resObj?.created_at,
            content: resObj?.message,
            unread_count: resObj?.unread_count,
            url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${resObj?.thanks_giving_id}`,
            icon: {
              original: "",
              large: "",
              medium:
                resObj.message_type == message_type
                  ? resObj?.to_user?.user_image
                  : resObj?.from_user?.user_id == 0
                  ? ""
                  : resObj?.from_user?.user_image,
              small: ""
            },
            point: {
              total: resObj?.points,
              pointAddition: false,
              state: resObj?.message_type
            },
            unread:
              resObj?.has_read === false
                ? true
                : false
          });
        });

        // スレッド機能利用要否 で利用しないで、一覧から選択したはポイントの詳細へ遷移
      } else {
        // サンクスポイント履歴を取得
        const pointHistoryList = await getPointHistoryList(
          "-name",
          1,
          undefined,
          "",
          undefined,
          50
        );
        // DX_IC-942
        if (pointHistoryList && pointHistoryList.results) {
          thanksPointList.results?.forEach((resObj: ThanksPoint) => {
            this.thanksPointList.push({
              id:
                resObj?.message_type == message_type
                  ? resObj?.to_user?.using_employee_id
                  : resObj?.from_user?.using_employee_id == 0
                  ? ""
                  : resObj?.from_user?.using_employee_id,
              name:
                resObj?.message_type == message_type
                  ? resObj?.to_user?.user_name
                  : resObj?.from_user?.user_id == 0
                  ? "－"
                  : resObj?.from_user?.user_name,
              date: resObj?.created_at,
              content: resObj?.message,
              unread_count: resObj?.unread_count,
              url: pointHistoryList.results?.find(
                (v: Transaction) =>
                  v.transaction_details?.pk === resObj.thanks_giving_id
              )?.pk
                ? `${CONST_DATA.SITE_MAP.DETAILS_GRANT_THANKS}?id=` +
                  pointHistoryList.results?.find(
                    (v: Transaction) =>
                      v.transaction_details?.pk === resObj.thanks_giving_id
                  )?.pk
                : "",
              icon: {
                original: "",
                large: "",
                medium:
                  resObj.message_type == message_type
                    ? resObj?.to_user?.user_image
                    : resObj?.from_user?.user_id == 0
                    ? ""
                    : resObj?.from_user?.user_image,
                small: ""
              },
              point: {
                total: resObj?.points,
                pointAddition: false,
                state: resObj?.message_type
              },
              unread:
                resObj?.has_read === false &&
                resObj?.message_type != message_type
                  ? true
                  : false
            });
          });

          // 履歴が取れない場合は基本的にはない（選択してもどこにも遷移しないようにしておく）
        } else {
          // DX_IC-942
          thanksPointList.results?.forEach((resObj: ThanksPoint) => {
            this.thanksPointList.push({
              id:
                resObj.message_type == message_type
                  ? resObj?.to_user?.using_employee_id
                  : resObj?.from_user?.using_employee_id == 0
                  ? ""
                  : resObj?.from_user?.using_employee_id,
              name:
                resObj.message_type == message_type
                  ? resObj?.to_user?.user_name
                  : resObj?.from_user?.user_id == 0
                  ? "－"
                  : resObj?.from_user?.user_name,
              date: resObj?.created_at,
              content: resObj?.message,
              unread_count: resObj?.unread_count,
              url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${resObj?.thanks_giving_id}`,
              icon: {
                original: "",
                large: "",
                medium:
                  resObj?.message_type == message_type
                    ? resObj?.to_user?.user_image
                    : resObj?.from_user?.user_id == 0
                    ? ""
                    : resObj?.from_user?.user_image,
                small: ""
              },
              point: {
                total: resObj?.points,
                pointAddition: false,
                state: resObj?.message_type
              },
              unread:
                resObj?.has_read === false &&
                resObj?.message_type != message_type
                  ? true
                  : false
            });
          });
        }
      }
    } else {
      this.thanksPointList = thanksPointList;
      if (this.thanksPointList?.count) {
        this.hasSearchResult = true;
      }
    }

    if (urlParams.has("search")) {
      const searchByUser: ListResponse<ThankPointSearchByUser> = await ThanksPointApi.searchThanksPointByUser(
        this.currentPage,
        this.pageSize,
        this.keyword
      );

      if (
        typeof searchByUser?.count !== undefined &&
        searchByUser?.count != 0
      ) {
        this.hasSearchResult = true;
        this.userSearchList = searchByUser;
      }
    }

    this.handlePagination(thanksPointList);
  }

  /**
   * Handle search
   *
   * @param {String} $event
   */
  async doSearch($event: string) {
    this.isLoading = true;
    this.hasSearchResult = false;
    this.thanksPointList = [];
    this.userSearchList = [];
    this.error = "";
    this.currentPage = 1;
    const title = document.title;
    const newUrl = this.pageNavi.baseUrl + this.keyword ? `?search=${this.keyword}` : ``;
    window.history.replaceState({}, title, newUrl);

    this.handleParam($event);

    const checkValidLength = checkLengthInput(this.keyword, 50);
    if (!checkValidLength?.isValid) {
      this.isLoading = false;
      this.error = checkValidLength?.error;
      this.isPagination = false;
      return false;
    }

    const checkValidNull = checkNullInput(this.keyword);
    if (!checkValidNull?.isValid) {
      this.error = checkValidNull?.error;
      this.isPagination = false;
      this.isSearch = true;      
    }

    const thanksPointList: ListResponse<ThanksPoint> = await ThanksPointApi.getThankPointList(
      this.currentPage,
      this.pageSize,
      this.keyword
    );
    if (
      typeof thanksPointList?.count !== undefined &&
      thanksPointList?.count != 0
    ) {
      this.hasSearchResult = true;
      this.thanksPointList = thanksPointList;
    }
	if (this.error.length <= 0) {
	  const searchByUser: ListResponse<ThankPointSearchByUser> = await ThanksPointApi.searchThanksPointByUser(
       this.currentPage,
        this.pageSize,
        this.keyword
      );

      this.isSearch = true;

      if (typeof searchByUser?.count !== undefined && searchByUser?.count != 0) {
        this.hasSearchResult = true;
        this.userSearchList = searchByUser;
      }	
	}

    this.isLoading = false;
    this.handlePagination(thanksPointList);
    this.handleURL();
  }

  handleParam($event: string) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageParam = urlParams.get("page");
    this.currentPage = pageParam ? parseInt(pageParam) : 1;

    const searchParam = $event || "";
    const searchPlusCharacter = searchParam.replaceAll("+", "%2B");
    const search = searchPlusCharacter.replaceAll("#", "%23");

    this.keyword = search || "";
    if (urlParams.has("search")) {
      this.handleURL();
    }
  }

  handlePagination(thanksPointList: any) {
    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }

    const nextPage = this.currentPage + 1;
    const count = thanksPointList?.count ?? 1;
    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    if (maxPage > 1) {
      this.isPagination = true;
    }
    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.nextPageUrl = this.pageNavi.baseUrl + "page=" + nextPage;
    this.pageNavi.prevPageUrl = this.pageNavi.baseUrl + "page=" + prevPage;
  }

  handleURL() {
    const queryString = window.location.search;
    const title = document.title;
    let newUrl = process.env.VUE_APP_IC_DOMAIN;
    const tempQs = queryString?.split("&");
    const tempUrl = [];
    for (const iterator of tempQs) {
      if (iterator.includes("search")) {
        tempUrl.push(iterator.replace(iterator, `search=${this.keyword}`));
      } else {
        tempUrl.push(iterator);
      }
    }

    if (this.isSearch && queryString === "") {
      tempUrl.push(`search=${this.keyword}`);
      tempUrl.push(`page=${this.pageNavi.currentPage}`);
    }
    newUrl =
      newUrl +
      this.baseUrl +
      tempUrl
        .filter(Boolean)
        .join("&")
        .replace("?", "");
    window.history.replaceState({}, title, newUrl);
  }
}
